import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  
  const tokenAuth = localStorage.getItem("1dTkApp");

  if (!tokenAuth) 
   {
    return <Navigate to="/" replace />;
   }

  return <Outlet />;
};

export default ProtectedRoute;
